import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { getUserDocumentRef } from "./util";
import { AuthActionKeyType, StatusType } from "./auth-context/reducer";
import { arrayUnion, updateDoc } from "firebase/firestore";
export var saveReadArticle = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(articleId, authContext) {
        var _authContext$, authenticated, user, userData, dispatch, userDocumentRef, readArticles;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _authContext$ = authContext[0], authenticated = _authContext$.authenticated, user = _authContext$.user, userData = _authContext$.userData, dispatch = authContext[1];
                        if (!authenticated) {
                            _context.next = 6;
                            break;
                        }
                        userDocumentRef = getUserDocumentRef(user.uid);
                        _context.next = 5;
                        return updateDoc(userDocumentRef, {
                            readArticles: arrayUnion(articleId)
                        });
                    case 5:
                        // Update context so we don't have to fetch data from firebase
                        if (userData.status === StatusType.SUCCESS) {
                            readArticles = [].concat(_toConsumableArray(userData.data.readArticles), [articleId]);
                            dispatch({
                                type: AuthActionKeyType.USER_DATA_SUCCESS,
                                payload: {
                                    data: Object.assign({}, userData.data, {
                                        readArticles: readArticles
                                    })
                                }
                            });
                        }
                    case 6:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function saveReadArticle(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
